import React from 'react';
import logo from '../../assets/logo.png';
import s from './Nav.module.scss';
import LogoutIcon from '@mui/icons-material/Logout';
import {useDispatch} from "react-redux";
import {AuthService} from "../../api/authService";
import {MenuItem} from "./MenuItem";
import { logOut } from "../../store/reducers/LoginReducer/LoginReducer";

const Nav = ({nav}) => {
    const dispatch = useDispatch();

    const logOutHandler = async() => {
        await AuthService.logout().then(res => {
            localStorage.removeItem("token");
            dispatch(logOut(false))
        });
    }

    return (
        <aside className={s.wrap}>
            <div className={s.brand}>
                <img src={logo} alt='Logo'/>
            </div>

            {nav && (
                <nav>
                    <ul className={s.list}>
                        {!!nav?.length && nav?.map((item) => <MenuItem key={item.id} item={item}/>)}
                    </ul>
                </nav>
            )}

            <div className={s.logout__container} onClick={() => logOutHandler()}>
                <div><LogoutIcon/></div>
                <div><span className={s.title}>Вихід</span></div>
            </div>
        </aside>
    );
};

export default Nav;
